import $ from 'cash-dom';

/**
 * This module animates / interpolates the 
 * intro polygon points while scrolling
 */
export default class IntroModule {

    static name = 'intro';

    constructor(node) {

        this.svg = $(node).find('svg');
        this.points = Array.from(this.svg.find('polygon').map((i, polygon) => ({
            polygon,
            start: $(polygon).attr('points').split(' ').map(point => point.split(',').map(parseFloat)),
            end: $(polygon).attr('data-points').split(' ').map(point => point.split(',').map(parseFloat))
        })));

        window.addEventListener('scroll', this.handleScroll);
    }

    handleScroll = (e) => {

        // let's scroll over one halb screen height
        const y = window.pageYOffset;
        const windowHeight = window.innerHeight * 0.8;
        const normalized = y / windowHeight; //Math.min(y / windowHeight, 1);

        if(normalized <= 0) return;

        // interpolate the points per polygon based on the normalized scroll position
        this.points.forEach((point) => {
            const polygon = point.polygon;
            const start = point.start;
            const end = point.end;

            const points = start.map((startPoint, i) => {
                const endPoint = end[i];
                const diff = endPoint.map((endPoint, j) => endPoint - startPoint[j]);
                const newPoint = startPoint.map((startPoint, j) => startPoint + diff[j] * normalized);
                return newPoint.join(',');
            }).join(' ');

            $(polygon).attr('points', points);
        });

        this.svg.css('--normalized', normalized);
    }
}